























































import { Component, Vue, Prop } from "vue-property-decorator";
import { GlobalStore } from "@/stores/GlobalStore";
import NewTableDialog from "./NewTableDialog.vue";
import { RoomData } from "../../classes/RoomData";
import { StandardDeck } from "../../classes/StandardDeck";
import { CardData } from "../../classes/CardData";

@Component({
  components: {
    NewTableDialog
  }
})
export default class Lobby extends Vue {
  @Prop(GlobalStore) readonly globalStore!: GlobalStore;

  get rooms() {
    return Array.from(this.globalStore.rooms).sort(
      (a, b) => b[1].createdAt - a[1].createdAt
    );
  }

  joinRoom(key: string) {
    this.globalStore.joinRoom(key);
  }

  roomCardsInOrder(roomData: RoomData) {
    return new StandardDeck(
      roomData.gameStoreData.roomConfig.deckConfig
    ).getCardsInOrder();
  }

  getCreatedString(createdAt: Date) {
    const now = Date.now();
    const diffMilliseconds = now - createdAt.getTime();
    const diffSeconds = Math.floor(diffMilliseconds / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffMinutes === 0) {
      return `just now`;
    } else if (diffHours === 0) {
      return `${diffMinutes}m ago`;
    } else if (diffDays === 0) {
      return `${diffHours}h ago`;
    } else if (diffDays === 1) {
      return `yersterday`;
    } else {
      return `${diffDays} days ago`;
    }
  }

  previewCardCSS(index: number, numberOfCards: number, cardData: CardData) {
    const color = `color: ${cardData.getColor().rgbaString};`;
    //const pos = `right: ${Math.floor((index / numberOfCards) * 100)}%;`;
    return color;
  }

  deleteCardRoom(e: MouseEvent, roomKey: string) {
    e.stopPropagation();
    this.globalStore.deleteCardRoom(roomKey);
  }
}
